import { mod11 } from './mod11'
import { validateIban } from './validateIban'

export function checkSwedishBankAccountNumber(accountNumberString: string) {
  const accountNumber = accountNumberString.replace(/\D/g, '')

  return accountNumber.length >= 11 && accountNumber.length <= 14
}

export function checkNorwegianBankAccountNumber(accountNumberString: string) {
  const accountNumber = accountNumberString.replace(/\D/g, '')

  return (
    accountNumber.length === 11 &&
    !accountNumber.startsWith('0000') &&
    mod11(accountNumber)
  )
}

export function checkDanishBankAccountNumber(accountNumber: string) {
  const parts = accountNumber.split('-')

  if (parts.length !== 2) {
    return false
  }

  const bic = parts[0]
  const iban = parts[1]

  if (bic?.length !== 8 && bic?.length !== 11) {
    return false
  }

  if (iban?.length !== 18) {
    return false
  }

  return validateIban(iban)
}
